/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Board_DescInputs */

const en_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response rates by job board and application method.`)
};

const de_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwortquoten nach Jobbörse und Bewerbungsmethode.`)
};

const fr_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux de réponse par site d'emploi et méthode de candidature.`)
};

const es_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasas de respuesta por portal de empleo y método de solicitud.`)
};

const it_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tassi di risposta per piattaforma di lavoro e metodo di candidatura.`)
};

const nl_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responspercentages per vacaturebank en sollicitatiemethode.`)
};

const pl_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wskaźniki odpowiedzi według portalu pracy i metody aplikacji.`)
};

const fi_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastausprosentit työpaikkasivustoittain ja hakumenetelmittäin.`)
};

const da_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svarprocenter efter jobportal og ansøgningsmetode.`)
};

const sv_analytics_board_desc = /** @type {(inputs: Analytics_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svarsfrekvens per jobbportal och ansökningsmetod.`)
};

/**
* | output |
* | --- |
* | "Response rates by job board and application method." |
*
* @param {Analytics_Board_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_board_desc = /** @type {((inputs?: Analytics_Board_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Board_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_board_desc(inputs)
	if (locale === "fr") return fr_analytics_board_desc(inputs)
	if (locale === "es") return es_analytics_board_desc(inputs)
	if (locale === "it") return it_analytics_board_desc(inputs)
	if (locale === "nl") return nl_analytics_board_desc(inputs)
	if (locale === "pl") return pl_analytics_board_desc(inputs)
	if (locale === "fi") return fi_analytics_board_desc(inputs)
	if (locale === "da") return da_analytics_board_desc(inputs)
	if (locale === "sv") return sv_analytics_board_desc(inputs)
	return en_analytics_board_desc(inputs)
});